module.exports = __webpack_public_path__ + "static/media/configuracion_sucursal.6a74a4c3.svg";